import { SubscriptionFeatureLimitM } from './../../models/organization-subscription/subscription-feature-limit.modal';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-subscription-limit-message',
    templateUrl: './subscription-limit-message.component.html',
    styleUrls: ['./subscription-limit-message.component.scss']
})

export class SubscriptionLimitMessageComponent implements OnChanges {

    @Input() subscriptionLimit: SubscriptionFeatureLimitM = null;
    @Input() moduleName: string = "";

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['subscriptionLimit'] && changes['subscriptionLimit']?.currentValue){
            this.subscriptionLimit = changes['subscriptionLimit']?.currentValue;
        }
    }
}
